var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},_vm._l((_vm.clientDocuments),function(doc,index){return _c('v-row',{key:index},[_c('v-col',{attrs:{"cols":"12"}},[_c('client-scan-card',{attrs:{"doc":doc},on:{"remove":function($event){return _vm.removeFile(index)}}})],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }